import { client } from '@/index';
import { dispatch } from '@/redux/store';
import { resetMerchantList } from '@/redux/slices/merchantList';

/**
 * Performs complete logout flow
 * Clears Redux state, localStorage, Apollo cache and reloads the page
 */
export const performLogout = async (): Promise<void> => {
  try {
    dispatch(resetMerchantList());

    try {
      localStorage.clear();
    } catch (storageError) {
      console.error('Failed to clear localStorage during logout', storageError);
    }

    try {
      await client.clearStore();
    } catch (apolloError) {
      console.error('Failed to clear Apollo client store during logout', apolloError);
    }
  } finally {
    window.location.reload();
  }
};
